import { useState } from "react";

type Callback = (...args: any[]) => void | Promise<any>;

export const useLoading = <T extends Callback>(callback: T): [T, boolean] => {
  const [isLoading, setLoading] = useState(false);

  const handleCallback = async (...args: any[]) => {
    setLoading(true);

    try {
      return await callback(...args);
    } finally {
      setLoading(false);
    }
  };

  return [handleCallback as T, isLoading];
};
